<template>
  <section v-if="selectedConversation" id="main-section" ref="customerInfo">
    <!-- Small customer information -->
    <div class="small-content p-2 border-bottom" v-if="!displayCustomerInfo">
      <div class="d-flex justify-content-start align-items-center">
        <div class="pr-2">
          <img v-lazy="selectedConversation.customer.profile_picture" class="rounded-circle img-circle-sm" width="32" />
        </div>
        <div class="flex-grow-1">
          <b>{{ selectedConversation.customer.name }}</b>
          <span class="text-secondary" v-if="selectedConversation.customer.beneat_user_id">
             | User Id:
            <a :href="'https://admin-test.beneat.co/user/' + selectedConversation.customer.beneat_user_id"
               target="_blank">
              {{ selectedConversation.customer.beneat_user_id }}
            </a>
          </span>
        </div>
        <div class="text-right">
          <button class="btn btn-primary btn-sm" @click="toggleCustomerInfo(true)">
            <i class="fas fa-caret-down"></i> ขยาย
          </button>
        </div>
      </div>
    </div>
    <!-- Big customer information -->
    <div class="bg-white text-small p-3 border-bottom" v-else>
      <div class="float-right">
        <button class="btn btn-light border btn-sm" @click.prevent="$emit('clearConversation')"><i class="fas fa-times"></i> ปิดการสนทนา</button>
        <button class="btn btn-primary btn-sm ml-2" @click="toggleCustomerInfo(false)">
          <i class="fas fa-caret-up"></i> ย่อ
        </button>
      </div>
      <div class="d-flex justify-content-start align-items-center" v-if="selectedConversation.customer">
        <div class="">
          <img v-lazy="selectedConversation.customer.profile_picture" class="rounded-circle img-circle-mlg" width="52"/>
        </div>
        <div class="px-3">
          <h5>
            <template v-if="selectedConversation.customer && selectedConversation.customer_type === 'beneat_professional' && selectedConversation.customer.beneat_professional">
              <span class="badge badge-danger" v-if="selectedConversation.customer.beneat_professional.status === 0">โดนปลด</span>
              <span class="badge badge-secondary" v-else-if="selectedConversation.customer.beneat_professional.professional_group_id === 0">0</span>
              <span class="badge badge-success" v-else-if="selectedConversation.customer.beneat_professional.professional_group_id === 1">A</span>
              <span class="badge badge-warning" v-else-if="selectedConversation.customer.beneat_professional.professional_group_id === 2">B</span>
              <span class="badge badge-warning" v-else-if="selectedConversation.customer.beneat_professional.professional_group_id === 3">C</span>
              <span class="badge badge-primary" v-else-if="selectedConversation.customer.beneat_professional.professional_group_id === 4">H</span>
            </template>

            {{ selectedConversation.customer.name }}
            <a href="" @click.prevent="displayModal()">
              <i class="fas fa-pencil-alt text-primary"></i>
            </a>
          </h5>
          <span class="d-inline-block pr-3 text-secondary" v-if="selectedConversation.customer.phone">
            <i class="fas fa-phone"></i> {{ selectedConversation.customer.phone }}
          </span>
          <span class="d-inline-block pr-3 text-secondary" v-if="selectedConversation.customer.email">
            <i class="fas fa-envelope"></i> {{ selectedConversation.customer.email }}
          </span>
          <span class="text-secondary" v-if="selectedConversation.customer.beneat_user_id">
            <i class="fas fa-user"></i>
            User Id:
            <a :href="'https://admin-test.beneat.co/user/' + selectedConversation.customer.beneat_user_id"
               target="_blank">
              {{ selectedConversation.customer.beneat_user_id }}
            </a>
          </span>
        </div>
      </div>

      <!-- Section Tags -->
      <div v-if="selectedConversation.tags">
        <div class="d-flex justify-content-start align-items-center py-2">
          <div class="rounded text-white mr-2"
               :style="`background-color: ${selectedSystemTag.color}`">

            <section v-if="selectedConversation.customer_type === 'customer'">
              <b-dropdown size="sm" :text="selectedSystemTag.name"
                          toggle-class="text-decoration-none text-white"
                          ref="dropdownSystemTag" variant="transparent">
                <b-card no-body>
                  <b-card-body class="message-template-area text-small p-0">
                    <div v-for="(systemTag, index) in multiLevelTags" :key="index">
                      <div v-if="systemTag.id !== 0"
                           class="p-2"
                           :class="{'row-message-template' : systemTag.can_select}"
                           :style="`color: #222222`"
                           @click="(systemTag.can_select) ? addCustomerChatTopicTag(systemTag) : null">
                        {{ systemTag.name }}
                      </div>
                      <div v-for="(childTag, key) in systemTag.child_tags" :key="key">
                        <div class="pl-4 py-2 row-message-template"
                             :style="`color: ${childTag.color}`"
                             @click="addCustomerChatTopicTag(childTag)">
                          {{ childTag.name }}
                        </div>
                      </div>
                      <div class="dropdown-divider"></div>
                    </div>
                  </b-card-body>
                </b-card>
                <b-dropdown-item-button class="text-center" @click="goToSystemTagSetting()">
                  ตั้งค่าหัวข้อสนทนา
                </b-dropdown-item-button>
              </b-dropdown>
            </section>
            <section v-else-if="selectedConversation.customer_type === 'beneat_professional'">
              <b-dropdown size="sm" :text="selectedSystemTag.name"
                          toggle-class="text-decoration-none text-white"
                          ref="dropdownChatTopic" variant="transparent">
                <b-card no-body>
                  <b-card-body class="message-template-area text-small p-0">
                    <div v-for="(chatTopic, index) in chatTopics" :key="index">
                      <div class="p-2"
                           :class="{'row-message-template' : chatTopic.can_select}"
                           @click="(chatTopic.can_select) ? updateProfessionalChatTopic(chatTopic) : null">{{ chatTopic.name }}
                      </div>
                      <div v-for="(childChatTopic, key) in chatTopic.child_chat_topics" :key="key">
                        <div class="pl-4 py-2 row-message-template"
                             @click="updateProfessionalChatTopic(childChatTopic)">
                          {{ childChatTopic.name }}
                        </div>
                      </div>
                      <div class="dropdown-divider"></div>
                    </div>
                  </b-card-body>
                </b-card>
              </b-dropdown>
            </section>
          </div>
          <!--          <div v-if="selectedSystemTag.id">-->
          <!--            <span class="text-dark ml-1"  @click="confirmDeleteConversationTag(selectedSystemTag)">-->
          <!--              <i class="fas fa-times -3"></i>-->
          <!--            </span>-->
          <!--          </div>-->
          <div>
            <b-dropdown size="sm" variant="secondary" text="เลือกแท็ก" toggle-class="text-decoration-none"
                        ref="dropdownTag">
              <b-card no-body>
                <b-card-body class="message-template-area text-small p-0">
                  <template v-for="(tag, index) in tags">
                    <div v-if="tag.id !== 0"
                         class="p-2 row-message-template"
                         :style="`color: ${tag.color}`"
                         @click="addConversationTag(tag)" :key="index">
                      <span class="d-inline-block pr-2"><i class="fas fa-tag"></i></span> {{ tag.name }}
                    </div>
                  </template>
                </b-card-body>
              </b-card>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item-button class="text-center" @click="goToTagSetting()">
                ตั้งค่าแท็ก
              </b-dropdown-item-button>
            </b-dropdown>
          </div>
          <div class="pl-2">
          <span v-if="selectedConversation.chat_topic">
              <span class="badge badge-dark conversation-tag mr-2"
                    style="'background-color:black;color:white;"
                    :style="{background: selectedConversation.chat_topic.color || '#000'}">
               {{ displayChatTopic(selectedConversation.chat_topic) }}
            </span>
          </span>

            <span v-for="(tag, index) in selectedConversation.tags" :key="index">
            <span class="badge badge-success conversation-tag mr-2"
                  :style="'background-color:' + tag.color"
                  v-if="!tag.system">
              {{ tag.name }}
              <div class="pl-1 d-inline-block" role="button"
                   @click="confirmDeleteConversationTag(tag)">
                <i class="fa fa-times text-white -3"></i>
              </div>
            </span>
          </span>
          </div>
        </div>
      </div>

      <hr class="my-2">
      <div class="row d-flex align-items-center">
        <div class="col-4">
          <div class="d-flex justify-content-start align-items-center">
<!--            <div class="mr-3" v-if="selectedConversation.admin">
              <img v-lazy="selectedConversation.admin.profile_picture" class="rounded-circle img-circle-md" width="40" alt="">
            </div>-->
            <div>
              <multiselect
                v-model="selectedConversation.admin"
                id="selectedAdmin"
                label="name"
                track-by="name"
                placeholder="แอดมินรับเคส"
                open-direction="bottom"
                ref="selectedItems"
                :options="admins"
                :searchable="true"
                :allow-empty="false"
                :deselectLabel="'ไม่สามารถลบแอดมินออกได้ ต้องปิดเคสเท่านั้น'"
                @input="setConversationAdmin">
<!--                <template slot="beforeList">
                  <div class="row">
                    <div class="col p-2 row-message-template">
                      <button class="btn btn-link btn-block text-reset text-decoration-none text-small" @click="selectAll">
                        เลือกทั้งหมด
                      </button>
                    </div>
                  </div>
                </template>-->
                <template slot="option" slot-scope="props">
                  <div class="option__desc d-inline-block">
                    <img :src="props.option.profile_picture" width="40" class="rounded-circle img-circle-md">
                    <span class="option__title">&nbsp;&nbsp;{{ props.option.name }}</span>
                  </div>
                </template>
                <template slot="singleLabel" slot-scope="{ option }">
                  <div class="d-flex justify-content-start align-items-center">
                    <div class="mr-2">
                      <img :src="option.profile_picture" width="40" class="rounded-circle img-circle-md">
                    </div>
                    <div>
                      <span class="text-small">{{ option.name.slice(0, 10) }}</span>
                    </div>
                  </div>
                </template>
              </multiselect>
<!--              <b-dropdown size="sm"
                          variant="light"
                          :text="(selectedConversation.admin) ? selectedConversation.admin.name : 'กำหนดแอดมิน'"
                          ref="dropdownAdmin">
                <b-card no-body>
                  <b-card-body class="message-template-area text-small p-0">
                    <div class=" d-flex align-items-center row-message-template p-2 border-bottom"
                         @click="setConversationAdmin(admin.id)"
                         v-for="(admin, index) in admins" :key="index">
                      <div class="mr-3">
                        <img v-lazy="admin.profile_picture" alt="" width="40" class="rounded-circle img-circle-md">
                      </div>
                      <div>
                        <div>{{ admin.name }}</div>
                        <div class="text-small text-secondary text-capitalize">{{ admin.role }}</div>
                      </div>
                    </div>
                  </b-card-body>
                </b-card>
              </b-dropdown>-->
            </div>
          </div>
        </div>
        <div class="col-8 text-right text-small" v-if="selectedConversation">
          <button class="btn btn-success btn-sm border mr-2"
                  v-if="checkCustomerType (selectedConversation.customer_type, selectedConversation.type)"
                  @click="createFeedbackUrl('th',selectedConversation.customer_type)">ประเมินความพึงพอใจ (TH)
          </button>
          <button class="btn btn-success btn-sm border mr-2"
                  v-if="selectedConversation.customer_type == 'customer'"
                  @click="createFeedbackUrl('en',selectedConversation.customer_type)">(EN)
          </button>
          <button class="btn btn-light btn-sm border mr-2"
                  @click="displayExpandModal()">ขยาย
          </button>
          <button class="btn btn-secondary btn-sm"
                  :disabled="(selectedConversation.is_archived === 1)"
                  @click="confirmSetArchive()">ปิดเคส
          </button>
        </div>
      </div>
    </div>
    <!-- Modal change customer name -->
    <div>
      <b-modal id="modal-edit-name"
               title="แก้ไขข้อมูลผู้ติดต่อ"
               ok-variant="info"
               ok-title="บันทึก"
               cancel-title="ยกเลิก"
               @ok="saveCustomerData()">
        <div class="form-group">
          <label for="name">ชื่อ</label>
          <input type="text"
                 class="form-control"
                 id="name"
                 placeholder="ชื่อ-สกุล"
                 v-model="selectedConversation.customer.name">
        </div>
        <div class="form-group">
          <label for="email">อีเมล</label>
          <input type="email"
                 class="form-control"
                 id="email"
                 placeholder="อีเมล"
                 v-model="selectedConversation.customer.email">
        </div>
        <div class="form-group">
          <label for="phone">เบอร์โทร</label>
          <input type="text"
                 class="form-control"
                 id="phone"
                 placeholder="เบอร์โทร"
                 v-model="selectedConversation.customer.phone">
        </div>
      </b-modal>
    </div>
    <!-- Modal change customer name -->
    <div>
      <b-modal id="modal-expand" hide-footer no-close-on-backdrop >
        <template #modal-header="">
          <b-form-checkbox switch v-model="showMessageCustomerAdmin" @change="(e) => showMessageAdmin(e)" >แสดงข้อความแอดมิน</b-form-checkbox>
          <b-button size="sm" variant="outline-danger" @click="closeShowMessage()">
            ปิด
          </b-button>
        </template>
        <div
          class="message-display py-4"
          ref="messageDisplay"
          :style="`height:${windowHeight}px; font-size: 80%;`"
          @scroll.passive="handleMessageScrollOnlyCustomer"
          v-if="messages">
          <div v-for="(message, index) in messages" :key="message.id || 'loading-' + index">
            <customer-chat
              :message="message"
              v-if="message.own === 0"/>
            <admin-chat
              :message="message"
              v-else/>
          </div>
        </div>
      </b-modal>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AdminChat from '@/components/coversation/AdminChat'
import CustomerChat from '@/components/coversation/CustomerChat'
import axios from 'axios'

export default {
  props: {
    selectedConversation: Object
  },
  components: {
    AdminChat,
    CustomerChat
  },
  data () {
    return {
      value: null,
      page: 0,
      windowHeight: window.innerHeight - 160,
      options: ['list', 'of', 'options'],
      selectedSystemTag: {
        id: null,
        name: 'เลือกหัวข้อสนทนา',
        color: '#607D8B'
      },
      displayCustomerInfo: true,
      showMessageCustomerAdmin: false
    }
  },
  computed: {
    ...mapState('tag', ['tags', 'systemTags', 'multiLevelTags']),
    ...mapState('admin', ['admins', 'admin']),
    ...mapState('message', ['messages', 'performScroll']),
    ...mapState('conversation', ['conversation']),
    ...mapState('chatTopic', ['chatTopics']),
    ...mapState({
      menuType: state => state.menu.type
    })
  },
  watch: {
    performScroll () {
      if (this.performScroll && this.$refs.messageDisplay) {
        setTimeout(() => {
          if (this.page === 0) {
            this.$refs.messageDisplay.scrollTop = this.$refs.messageDisplay.scrollHeight
          } else {
            this.$refs.messageDisplay.scrollTop = this.$refs.messageDisplay.scrollHeight - this.contentHeight
          }
        }, 250)
      }
    },
    'selectedConversation': function (newVal, oldVal) {
      // console.log('check selected conversation', newVal)
      this.displayCustomerInfo = true
      if (this.selectedConversation && this.selectedConversation.customer_type === 'customer') {
        if (this.selectedConversation.customer_chat_topic_tag) {
          this.selectedSystemTag.name = this.selectedConversation.customer_chat_topic_tag.name
          this.selectedSystemTag.id = this.selectedConversation.customer_chat_topic_tag.id
          this.selectedSystemTag.color = this.selectedConversation.customer_chat_topic_tag.color
        } else {
          this.selectedSystemTag.name = 'เลือกหัวข้อสนทนา'
          this.selectedSystemTag.id = null
          this.selectedSystemTag.color = '#607D8B'
        }
      } else if (this.selectedConversation && this.selectedConversation.customer_type === 'beneat_professional') {
        this.selectedSystemTag.name = 'เลือกหัวข้อสนทนา'
        this.selectedSystemTag.id = null
        this.selectedSystemTag.color = '#607D8B'
        if (this.selectedConversation.professional_chat_topic) {
          this.selectedSystemTag.name = this.selectedConversation.professional_chat_topic.name
        }
      }
    }
  },
  methods: {
    ...mapActions('menu', ['fetchMenuCount']),
    ...mapActions('chatTopic', ['fetchProfessionalChatTopics']),
    ...mapActions('conversation', ['searchCustomer', 'fetchConversation']),
    ...mapActions('customer', ['saveCustomer']),
    ...mapActions('message', ['fetchMessages']),
    toggleCustomerInfo (status) {
      this.displayCustomerInfo = status
      setTimeout(() => {
        const height = this.$refs.customerInfo.clientHeight
        this.$emit('toggleCustomerInfo', height)
      }, 250)
    },
    hasCustomerChatTopic (tags) {
      let result = false
      for (const tag of tags) {
        if (tag.system) {
          result = true
          break
        }
      }
      return result
    },
    displayModal () {
      this.$bvModal.show('modal-edit-name')
    },
    displayExpandModal () {
      if (this.selectedConversation) {
        // id and own
        this.showMessageCustomerAdmin = false
        this.loadFirstMessages(this.selectedConversation.id, 0)
        this.$bvModal.show('modal-expand')
      }
    },
    displayChatTopic (chatTopic) {
      if (chatTopic.parent_id !== 0 && chatTopic.parent_chat) {
        return `${chatTopic.parent_chat.name} - ${chatTopic.name}`
      } else {
        return `${chatTopic.name}`
      }
    },
    async saveCustomerData () {
      if (this.selectedConversation.customer.name) {
        const customer = {
          id: this.selectedConversation.customer.id,
          name: this.selectedConversation.customer.name,
          phone: this.selectedConversation.customer.phone,
          email: this.selectedConversation.customer.email
        }
        const submitData = {
          customer: customer,
          conversation_id: this.selectedConversation.id
        }
        await this.saveCustomer(submitData)
        const params = {
          phone: this.selectedConversation.customer.phone,
          email: this.selectedConversation.customer.email,
          line_user_id: this.selectedConversation.customer.lid,
          customer_id: this.selectedConversation.customer.id,
          beneat_professional_id: this.selectedConversation.customer.beneat_professional_id
        }
        await this.searchCustomer(params)
        this.$bvModal.hide('modal-edit-name')
      } else {
        this.$swal({ text: 'กรุณากรอกชื่อ' })
      }
    },
    confirmSetArchive () {
      if (this.selectedConversation.is_archived === 0) {
        this.$swal({
          text: 'คุณต้องการปิดเคสการสนทนานี้ใช่หรือไม่',
          showCancelButton: true,
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        }).then(async (result) => {
          if (result.isConfirmed) {
            await this.setConversationArchive(false)
          }
        })
      }
    },
    confirmDeleteConversationTag (tag) {
      this.$swal({
        text: 'คุณต้องการลบแท็กนี้ใช่หรือไม่',
        showCancelButton: true,
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.deleteConversationTag(tag)
        }
      })
    },
    async createFeedbackUrl (lang, type) {
      let url = '/conversations/feedback-url'
      const params = {
        admin_id: this.admin.id,
        conversation_id: this.selectedConversation.id
      }
      if (type === 'beneat_professional') {
        url = '/conversations/feedback-professional-url'
      } else if (type === 'professional') {
        url = '/conversations/feedback-professional-register-url'
      }
      const { data } = await axios.get(url, { params })
      // console.log('data :', data)
      if (!data.error && data.feedback) {
        let text = `[ข้อความอัตโนมัติ] BeNeat Customer Service สวัสดีค่ะ ขอบพระคุณคุณลูกค้าที่ให้โอกาสเจ้าหน้าที่ได้อำนวยความสะดวกคุณลูกค้าครั้งนี้ กรุณาให้คะแนนประเมินการติดต่อประสานงานของเจ้าหน้าที่ในครั้งนี้ https://beneat.co/feedback/operation?id=${data.feedback.id}`
        if (type === 'beneat_professional') {
          text = `[ข้อความอัตโนมัติ] BeNeat Customer Service สวัสดีค่ะ เราขอขอบคุณ คุณแม่บ้านที่ให้โอกาสเจ้าหน้าที่ได้อำนวยความสะดวกในครั้งนี้ กรุณาให้คะแนนประเมินการติดต่อประสานงานของเจ้าหน้าที่ในครั้งนี้ https://beneat.co/feedback/operation-professional?id=${data.feedback.id}`
        } else if (type === 'professional') {
          text = `[ข้อความอัตโนมัติ] ยินดีด้วยค่ะ คุณแม่บ้านผ่านหลักสูตรการอบรม คุณแม่บ้าน BeNeat แบบมืออาชีพ กรุณาประเมินความพึงพอใจในการอบรมครั้งนี้ ขอบพระคุณค่ะ https://beneat.co/feedback/operation-professional-register?id=${data.feedback.id}`
        }

        if (lang === 'en') {
          text = `[Automatic Message] Thank you for giving our staff the opportunity to assist you on this occasion. Please rate your satisfaction with how our staff coordinated and communicated with you during this interaction.  https://beneat.co/feedback/operation?id=${data.feedback.id}&lang=en`
          if (type === 'beneat_professional') {
            text = `[Automatic Message] Hello,  we would like to say thank you for giving our staff the opportunity assisting you this time. Please provide a rating for the coordination of our staff on this occasion.  https://beneat.co/feedback/operation-professional?id=${data.feedback.id}&lang=en`
          }
        }
        await navigator.clipboard.writeText(text)
        this.$swal({ text: 'Copy สำเร็จ', icon: 'success' })
      } else {
        if (data.message) {
          this.$swal({ text: data.message, icon: 'error' })
        }
      }
    },
    async setConversationAdmin (admin) {
      if (!admin) {
        return
      }
      const adminId = admin.id
      const url = `/conversations/${this.selectedConversation.id}`
      const submitData = {
        admin_id: adminId,
        assign_to_admin_id: adminId,
        assign_from_admin_id: this.admin.id,
        is_archived: 0
      }
      await axios.put(url, submitData)
      // console.log('res', res)
      // this.$refs.dropdownAdmin.hide(true)
    },
    async setConversationArchive () {
      const url = `/conversations/${this.selectedConversation.id}`
      const submitData = {
        admin_id: 0,
        admin_id_close: this.admin.id,
        is_archived: 1,
        beneat_chat_topic_id: null,
        customer_chat_topic_tag_id: null,
        close_case_lumen: 1,
        remind_at: null,
        active_menu: this.menuType
      }
      await axios.put(url, submitData)
      this.$emit('clearReminder')
      this.fetchMenuCount()
    },
    async addCustomerChatTopicTag (tag) {
      if (tag) {
        this.$refs.dropdownSystemTag.hide(true)
        await this.setConversationArchive()
        // if change customer chat topic tag need to set archive conversation first and then change new tag
        const submitData = {
          admin_id: this.admin.id
        }
        const url = `/conversations/${this.selectedConversation.id}/tags/${tag.id}`
        await axios.post(url, submitData)
        this.selectedSystemTag = tag
        // console.log('res', res)
      }
    },
    async addConversationTag (tag) {
      this.$refs.dropdownTag.hide(true)
      // if change customer chat topic tag need to set archive conversation first and then change new tag
      const submitData = {
        admin_id: this.admin.id
      }
      const url = `/conversations/${this.selectedConversation.id}/tags/${tag.id}`
      await axios.post(url, submitData)
    },
    async deleteConversationTag (tag) {
      const url = `/conversations/${this.selectedConversation.id}/tags/${tag.id}`
      await axios.delete(url)
    },
    async handleMessageScroll ({
      target: { scrollTop, clientHeight, scrollHeight }
    }) {
      // console.log('oh yeahhh scroll')
      if (scrollTop === 0) {
        this.contentHeight = scrollHeight
        if (this.selectedConversation) {
          await this.loadMoreMessages(this.selectedConversation.id)
        }
      }
    },
    async loadFirstMessages (conversationId, own = undefined) {
      // Load messages
      this.$store.commit('message/SET_MESSAGES', [])
      this.page = 0
      const params = {
        conversation_id: conversationId,
        page: this.page,
        own: own
      }
      await this.fetchMessages(params)
    },
    async loadMoreMessages (conversationId, own = undefined) {
      this.page = this.page + 1
      const params = {
        conversation_id: conversationId,
        page: this.page,
        own: own
      }
      await this.fetchMessages(params)
    },
    async updateProfessionalChatTopic (chatTopic) {
      this.$refs.dropdownChatTopic.hide(true)
      await this.setConversationArchive()
      // if change customer chat topic tag need to set archive conversation first and then change new tag
      const submitData = {
        admin_id: this.admin.id,
        conversation_id: this.selectedConversation.id,
        beneat_chat_topic: chatTopic,
        beneat_professional_id: this.selectedConversation.customer.beneat_professional_id
      }
      const url = '/beneat/update-chat-topic'
      await axios.post(url, submitData)
      this.selectedSystemTag.name = chatTopic.name
    },
    goToTagSetting () {
      this.$router.push('/settings/tag')
    },
    goToSystemTagSetting () {
      this.$router.push('/settings/tag?system=1')
    },
    async showMessageAdmin (e) {
      this.$store.commit('message/SET_MESSAGES', [])
      if (e === true && this.selectedConversation) {
        // console.log('only admin')
        await this.loadFirstMessages(this.selectedConversation.id)
      } else {
        // console.log('only customer')
        await this.loadFirstMessages(this.selectedConversation.id, 0)
      }
    },
    async handleMessageScrollOnlyCustomer ({
      target: { scrollTop, clientHeight, scrollHeight }
    }) {
      if (scrollTop === 0) {
        this.contentHeight = scrollHeight
        if (this.selectedConversation) {
          if (this.showMessageCustomerAdmin === true) {
            await this.loadMoreMessages(this.selectedConversation.id)
          } else {
            await this.loadMoreMessages(this.selectedConversation.id, 0)
          }
        }
      }
    },
    async closeShowMessage () {
      await this.loadFirstMessages(this.selectedConversation.id)
      this.$bvModal.hide('modal-expand')
    },
    checkCustomerType (customerType, type) {
      if (customerType === 'customer') {
        return true
      } else if (customerType === 'beneat_professional') {
        return true
      } else if (customerType === 'professional') {
        if (type === 'PrivateConversation') {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    }
  },
  mounted () {
    this.fetchProfessionalChatTopics()
  }
}
</script>

<style lang="scss" scoped>

section#main-section {
  transition: all 0.5s linear;
}

.hidden-content {
  overflow: hidden;
  max-height: 85px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
